export default "__VITE_ASSET__436cb52e__"